module.exports = __webpack_public_path__ + "static/img/新理财 第十七届中国CFO大会.3f20df50.png";